export default {
    'mobile': '(max-width: 767px)',
    'tablet': '(max-width: 1023px)',
    'desktop': '(min-width: 1024px)',
};
